module.exports = __webpack_public_path__ + "img/105.38728f43.svg";